"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepMapObject = exports.getAbsoluteProperty = exports.untypedGetProp = void 0;

exports.untypedGetProp = function (obj) {
  var e_1, _a;

  var args = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }

  var lastObj = obj;

  try {
    for (var args_1 = __values(args), args_1_1 = args_1.next(); !args_1_1.done; args_1_1 = args_1.next()) {
      var key = args_1_1.value;

      if (typeof lastObj !== "object" || lastObj === null) {
        return undefined;
      }

      lastObj = lastObj[key];
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (args_1_1 && !args_1_1.done && (_a = args_1.return)) _a.call(args_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return lastObj;
};

function getAbsoluteProperty(obj, deepKey) {
  var e_2, _a;

  var keys = deepKey.split(".");
  var last = obj;

  try {
    for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
      var key = keys_1_1.value;
      last = last === null || last === void 0 ? void 0 : last[key];
      if (last === null || typeof last !== "object") break;
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
    } finally {
      if (e_2) throw e_2.error;
    }
  }

  return last;
}

exports.getAbsoluteProperty = getAbsoluteProperty;

exports.deepMapObject = function (obj, decisionFn) {
  var decision = decisionFn(obj, []);

  if (decision.stop) {
    return decision.newVal;
  }

  var helper = function helper(prefixes, obj, final) {
    if (final === void 0) {
      final = {};
    }

    for (var key in obj) {
      var val = obj[key];

      var path = __spread(prefixes, [key]);

      var decision_1 = decisionFn(val, path);

      if (decision_1.stop) {
        final[key] = decision_1.newVal;
      } else if (typeof val === "object") {
        final[key] = {};
        helper(path, obj[key], final[key]);
      }
    }

    return final;
  };

  var result = helper([], obj);
  return result;
};